// Auth Events - Communication between Apollo and Auth Context
// This allows Apollo error link to trigger logout in AuthContext

type AuthEventListener = () => void;

class AuthEventEmitter {
  private listeners: Set<AuthEventListener> = new Set();

  // Subscribe to auth expired events
  subscribe(listener: AuthEventListener): () => void {
    this.listeners.add(listener);
    return () => {
      this.listeners.delete(listener);
    };
  }

  // Emit auth expired event (called by Apollo on 401)
  emitAuthExpired(): void {
    this.listeners.forEach((listener) => {
      try {
        listener();
      } catch (error) {
        console.error('Auth event listener error:', error);
      }
    });
  }
}

export const authEvents = new AuthEventEmitter();
